/**
 * Sesotho: Files
 *
 * What this file covers: Uploading files and previewing them (documents, images, audio, video).
 *
 * Tone: Short functional labels, like a file manager.
 *
 * Sesotho: Everyday Sesotho as used in South African business. Keys not translated yet fall back to English, so
 * a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const files: Catalog = {
  'upload.prompt': 'Lahlela faele mona, kapa u tobetse ho batla',
  'upload.library': 'Khetha laeboraring',
  'upload.library.title': 'Laeborari ea mecha ea litaba',
  'upload.library.search': 'Batla ka lebitso la faele',
  'upload.library.empty': 'Ha ho letho hajoale. Kenya faele ho e bona mona.',
  'upload.library.more': 'Kenya tse ling',
  'upload.uploading': 'Ea kenya',
  'upload.replace': 'Fetola',
  'upload.rename': 'Reha lebitso le lecha',
  'upload.rename.title': 'Reha faele lebitso le lecha',
  'upload.rename.placeholder': 'Lebitso la faele',
  'upload.copy': 'Kopitsa sehokelo',
  'upload.copied': 'E kopitsitsoe',
  'upload.select': 'Khetha',
  'upload.delete': 'Hlakola ka ho sa feleng',
  'upload.delete.confirm': 'Hlakola faele ena ho bohle? Ntho leha e le efe e ntseng e e sebelisa e tla senyeha.',
  'upload.filter.all': 'Tsohle',
  'upload.filter.image': 'Litšoantšo',
  'upload.filter.video': 'Video',
  'upload.filter.document': 'Litokomane',
  'upload.error.tooLarge': 'Faele eo e kholo haholo.',
  'upload.error.type': 'Mofuta oo oa faele ha o amoheloe.',
  'upload.error.infected': 'Faele eo e hlolehile tlhahlobong ea vaerase \'me ha ea bolokoa.',
  'upload.error.scanUnavailable': 'Sehlahlobi sa vaerase ha se fumanehe. Leka hape haufinyane.',
  'upload.error.notConfigured': 'Polokelo ea difaele ha e so behoe. Mosebetsi o tlameha ho e beha tlas\'a Litlhophiso, Likopanyo.',
  'upload.error.generic': 'Ho kenya ha hloleha.'
};

export default files;
